<div class="container single-view" id="add-code-order">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/code-orders/" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'CODE_ORDERS.BTN_BACK_TO_CODE_ORDER' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-order-title" class="section-title">{{ 'CODE_ORDER_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-order-subtitle" class="section-subtitle mt-1 text-base">{{ 'CODE_ORDER_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            @if (hasSerialisationSettings) {
              <form class="mt-0" [formGroup]="codeOrderForm" data-testid="add-order-form">
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 data-testid="add-order-details-title" class="border-b pb-3">{{ 'CODE_ORDER_CREATE.CODE_ORDERS_DETAILS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-auto">
                    <label data-testid="add-order-type" class="block mb-2">{{ 'CODE_ORDER_CREATE.CODE_ORDER_TYPE' | translate }} <i class="icon-required-field"></i></label>
                    <div class="row">
                      <div class="col-12">
                        <label data-testid="add-order-type-warranty-label" class="inline-flex mr-6">
                          <p-radioButton data-testid="add-order-type-warranty" name="codeOrderType" value="warranty-codes" formControlName="codeOrderType" inputId="warranty-codes" />
                          <span for="warranty-codes" class="ml-2">{{ 'CODE_ORDERS.WARRANTY_CODES' | translate }} </span>
                        </label>
                        <label data-testid="add-order-type-aggregatedproduct-label" class="inline-flex mr-6">
                          <p-radioButton data-testid="add-order-type-aggregatedproduct" name="codeOrderType" value="aggregated-product-codes" formControlName="codeOrderType" inputId="aggregated-product-codes" />
                          <span for="aggregated-product-codes" class="ml-2">{{ 'CODE_ORDERS.AGGREGATED_PRODUCT_CODES' | translate }}</span>
                        </label>
                        <label data-testid="add-order-type-item-label" class="inline-flex mr-6">
                          <p-radioButton data-testid="add-order-type-item" name="codeOrderType" value="item-codes" formControlName="codeOrderType" inputId="item-codes" />
                          <span for="item-codes" class="ml-2">{{ 'CODE_ORDERS.ITEM_CODES' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  @if (codeOrderForm.get('codeOrderType')?.value !== 'item-codes') {
                    <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-6 col-xl-4 col-xxl-3">
                      <label data-testid="add-order-field-quantity" for="quantity">{{ 'CODE_ORDER_CREATE.QUANTITY' | translate }} <i class="icon-required-field"></i></label>
                      <input data-testid="add-order-quantity-input" type="number" id="quantity" formControlName="quantity" autocomplete="off">
                      @if (codeOrderForm.get('quantity')?.invalid && codeOrderForm.get('quantity')?.touched) {
                        <small data-testid="quantity-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                      }
                    </div>
                  }
                  @if (codeOrderForm.get('codeOrderType')?.value === 'item-codes') {
                    <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12">
                      <p class="label w-full pb-2 mb-2 border-b">{{ 'CODE_ORDER_CREATE.CLICK_TO_ADD_PRODUCTS' | translate }}</p>
                    </div>
                    <div class="field-wr flex flex-col col-12 col-sm-12 col-md-2 pb-2">
                      <button data-testid="add-order-add-product-btn" class="btn outline-btn" type="button" (click)="addProduct()">{{ 'CODE_ORDER_CREATE.BTN_ADD_PRODUCT' | translate }}</button>
                    </div>
                    @if (!productsFormArray.controls.length) {
                      <div class="container">
                        <div class="row rounded-card mt-4 py-6">
                          <div class="col-12">
                            <p data-testid="add-order-item-no-data">{{ 'CODE_ORDER_CREATE.ITEM_CODES_NO_DATA' | translate }}</p>
                          </div>
                        </div>
                      </div>
                    } @else {
                      <div class="col-12">
                        @for (product of productsFormArray.controls; track product; let i = $index) {
                          <div class="row rounded-card mt-4"
                            [attr.id]="'product-' + i">
                            <div class="flex flex-col col-12 mb-2">
                              <div class="flex items-center">
                                <h4 data-testid="add-order-create-product">{{ 'CODE_ORDER_CREATE.PRODUCT' | translate }} <span class="product-counter">#{{i + 1}}</span>
                              </h4>
                              <button data-testid="add-order-remo-product-btn" class="btn borderless-btn btn-icon icon-trash"
                                pTooltip="{{ 'CODE_ORDER_CREATE.BTN_REMOVE_PRODUCT' | translate }}" tooltipPosition="top"
                              (click)="removeProduct(i)"></button>
                            </div>
                          </div>
                          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3">
                            <label [attr.data-testid]="'add-order-field-product-' + i"  class="block text-sm" for="productId">{{ 'CODE_ORDER_CREATE.PRODUCT' | translate }} <i class="icon-required-field"></i></label>
                            <app-custom-dropdown
                              [data-testid]="'product-' + i"
                              [placeholder]="'CODE_ORDER_CREATE.SELECT_PRODUCT_PLACEHOLDER' | translate"
                              optionLabel="text"
                              optionValue="id"
                              [isMultiselect]="false"
                              [showSelectionChips]="true"
                              [showClear]="false"
                              [searchMode]="'remote'"
                              [pageSize]="comboData.rowsPerPageOption || 5"
                              [totalCount]="comboData.totalRecords"
                              [totalPages]="getComboTotalPages()"
                              [options]="comboData.list"
                              [formControl]="getProductControl(i)"
                              (onLazyLoad)="onLazyLoadComboData($event)">
                            </app-custom-dropdown>
                          </div>
                          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2">
                            <label [attr.data-testid]="'add-order-field-quantity-' + i" for="quantity">{{ 'CODE_ORDER_CREATE.QUANTITY' | translate }} <i class="icon-required-field"></i></label>
                            <input [attr.data-testid]="'add-order-quantity-input-' + i" type="number" [formControl]="getQuantityControl(i)" autocomplete="off">
                          </div>
                        </div>
                      }
                    </div>
                  }
                }
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-order-create-btn" class="btn primary-btn" [disabled]="!isFormValid" (click)="submitForm()">{{ 'CODE_ORDER_CREATE.BTN_CREATE_CODE_ORDER' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
          } @else {
            <div class="rounded-card pt-2 pb-4 px-4">
              <h3 class="mb-0">{{ 'CODE_ORDER_CREATE.SERIALISATION_SETTINGS_MISSING_TITLE' | translate }}</h3>
              <p data-testid="missing-serialisation-settings-message">{{ 'CODE_ORDER_CREATE.SERIALISATION_SETTINGS_MISSING_MESSAGE' | translate }}</p>
            </div>
          }
          <!-- /main content -->
        </div>
      </div>
    </div>
  </div>
</div>
</div>
